import { render, staticRenderFns } from "./LodgingDiscountBadge.vue?vue&type=template&id=f87e940a&scoped=true&"
import script from "./LodgingDiscountBadge.vue?vue&type=script&lang=js&"
export * from "./LodgingDiscountBadge.vue?vue&type=script&lang=js&"
import style0 from "./LodgingDiscountBadge.vue?vue&type=style&index=0&id=f87e940a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87e940a",
  null
  
)

export default component.exports